<div [ngClass]="{
    active: docsEditable,
    'd-flex justify-content-between flex-row-reverse flex-wrap': showAttachmentsTitle
  }" class="files-preview-container">
  <div class="custom_upload d-flex align-items-start" *ngIf="renderBtn">
    <div *ngIf="invalidFile || fileMaxSiZeErorr || (selectedfilesCount > maxFiles && maxFiles > 1)">
      <ul>
        <li *ngIf="invalidFile">
          <div class="alert alert-danger">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 30 30">
              <g id="remove-ic" transform="translate(0 0.006)">
                <circle id="circle" cx="15" cy="15" r="15" transform="translate(0 -0.006)" fill="#dc3545" />
                <path id="ic_close"
                  d="M211.746-746.861l5.01,5.005a1.135,1.135,0,0,0,.827.356,1.094,1.094,0,0,0,.814-.356,1.1,1.1,0,0,0,.35-.819,1.127,1.127,0,0,0-.35-.807l-5.01-5.018,5.01-5.018a1.1,1.1,0,0,0,.343-.807,1.146,1.146,0,0,0-.343-.819,1.094,1.094,0,0,0-.814-.356,1.155,1.155,0,0,0-.827.343l-5.01,5.018-5.023-5.018a1.113,1.113,0,0,0-.814-.343,1.135,1.135,0,0,0-.827.356,1.122,1.122,0,0,0-.337.819,1.126,1.126,0,0,0,.35.807l5.01,5.018-5.01,5.018a1.1,1.1,0,0,0-.343.807,1.146,1.146,0,0,0,.343.819,1.094,1.094,0,0,0,.814.356,1.094,1.094,0,0,0,.814-.356Z"
                  transform="translate(-196.746 763.494)" fill="#fff" />
              </g>
            </svg>
            {{"fileManager.invalidFileExtensions"|translate}}
          </div>
        </li>
        <li *ngIf="fileMaxSiZeErorr">
          <div class="alert alert-danger">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 30 30">
              <g id="remove-ic" transform="translate(0 0.006)">
                <circle id="circle" cx="15" cy="15" r="15" transform="translate(0 -0.006)" fill="#dc3545" />
                <path id="ic_close"
                  d="M211.746-746.861l5.01,5.005a1.135,1.135,0,0,0,.827.356,1.094,1.094,0,0,0,.814-.356,1.1,1.1,0,0,0,.35-.819,1.127,1.127,0,0,0-.35-.807l-5.01-5.018,5.01-5.018a1.1,1.1,0,0,0,.343-.807,1.146,1.146,0,0,0-.343-.819,1.094,1.094,0,0,0-.814-.356,1.155,1.155,0,0,0-.827.343l-5.01,5.018-5.023-5.018a1.113,1.113,0,0,0-.814-.343,1.135,1.135,0,0,0-.827.356,1.122,1.122,0,0,0-.337.819,1.126,1.126,0,0,0,.35.807l5.01,5.018-5.01,5.018a1.1,1.1,0,0,0-.343.807,1.146,1.146,0,0,0,.343.819,1.094,1.094,0,0,0,.814.356,1.094,1.094,0,0,0,.814-.356Z"
                  transform="translate(-196.746 763.494)" fill="#fff" />
              </g>
            </svg>
            {{"fileManager.maxFileSize"|translate}} {{maxSize}} {{'forms.MB' | translate}}
          </div>
        </li>
        <li *ngIf="selectedfilesCount > maxFiles && maxFiles > 1">
          <div class="alert alert-danger">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 30 30">
              <g id="remove-ic" transform="translate(0 0.006)">
                <circle id="circle" cx="15" cy="15" r="15" transform="translate(0 -0.006)" fill="#dc3545" />
                <path id="ic_close"
                  d="M211.746-746.861l5.01,5.005a1.135,1.135,0,0,0,.827.356,1.094,1.094,0,0,0,.814-.356,1.1,1.1,0,0,0,.35-.819,1.127,1.127,0,0,0-.35-.807l-5.01-5.018,5.01-5.018a1.1,1.1,0,0,0,.343-.807,1.146,1.146,0,0,0-.343-.819,1.094,1.094,0,0,0-.814-.356,1.155,1.155,0,0,0-.827.343l-5.01,5.018-5.023-5.018a1.113,1.113,0,0,0-.814-.343,1.135,1.135,0,0,0-.827.356,1.122,1.122,0,0,0-.337.819,1.126,1.126,0,0,0,.35.807l5.01,5.018-5.01,5.018a1.1,1.1,0,0,0-.343.807,1.146,1.146,0,0,0,.343.819,1.094,1.094,0,0,0,.814.356,1.094,1.094,0,0,0,.814-.356Z"
                  transform="translate(-196.746 763.494)" fill="#fff" />
              </g>
            </svg>
            {{ "forms.uploadedFilesExceeded" | translate : { num: maxFiles } }}
          </div>
        </li>
      </ul>
    </div>
    <button class="mat-mauve-light button_with_icon" mat-raised-button (click)="fileDropRef.click()"
      [disabled]="Disapled">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path id="ic_add"
          d="M87.2-871.2v2.4a.774.774,0,0,0,.23.57A.774.774,0,0,0,88-868a.774.774,0,0,0,.57-.23.774.774,0,0,0,.23-.57v-2.4h2.4a.774.774,0,0,0,.57-.23A.774.774,0,0,0,92-872a.774.774,0,0,0-.23-.57.774.774,0,0,0-.57-.23H88.8v-2.4a.774.774,0,0,0-.23-.57A.774.774,0,0,0,88-876a.774.774,0,0,0-.57.23.774.774,0,0,0-.23.57v2.4H84.8a.774.774,0,0,0-.57.23A.774.774,0,0,0,84-872a.774.774,0,0,0,.23.57.774.774,0,0,0,.57.23ZM88-864a7.79,7.79,0,0,1-3.12-.63,8.079,8.079,0,0,1-2.54-1.71,8.078,8.078,0,0,1-1.71-2.54A7.79,7.79,0,0,1,80-872a7.79,7.79,0,0,1,.63-3.12,8.079,8.079,0,0,1,1.71-2.54,8.079,8.079,0,0,1,2.54-1.71A7.789,7.789,0,0,1,88-880a7.789,7.789,0,0,1,3.12.63,8.079,8.079,0,0,1,2.54,1.71,8.079,8.079,0,0,1,1.71,2.54A7.79,7.79,0,0,1,96-872a7.79,7.79,0,0,1-.63,3.12,8.079,8.079,0,0,1-1.71,2.54,8.079,8.079,0,0,1-2.54,1.71A7.79,7.79,0,0,1,88-864Z"
          transform="translate(-80 880)" fill="#5a5096" />
      </svg>
      {{"wikiCategories.addDocument"|translate}}
    </button>
  </div>
  <input #fileDropRef (change)="fileBrowseHandler(fileDropRef)" [attr.id]="'fileDropRef_' + managerIndex"
    [disabled]="Disapled" [multiple]="maxFiles > 1"  [accept]="acceptExt" type="file" style="display: none;" />

  <div (fileDropped)="onFileDropped($event)" *ngIf="!renderBtn" [class.loading]="loading" [hidden]="!docsEditable"
    appDnd class="dnd-container">
    <input #fileDropRef
      (change)="fileBrowseHandler(fileDropRef)"
      [attr.id]="'fileDropRef_' + managerIndex"
      [disabled]="Disapled"
      [multiple]="maxFiles > 1"
      [accept]="acceptExt"
      type="file" />
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="25" viewBox="0 0 19 25">
        <path id="upload-icon"
          d="M2.336,25A2.322,2.322,0,0,1,0,22.7V6.956H4.725a2.321,2.321,0,0,0,2.335-2.3V0h9.605A2.317,2.317,0,0,1,19,2.3V22.7A2.317,2.317,0,0,1,16.665,25Zm6.421-5.439a.743.743,0,0,0,1.486,0V14.269l1.916,1.887a.75.75,0,0,0,1.051,0,.723.723,0,0,0,0-1.035l-3.185-3.138a.749.749,0,0,0-1.05,0L5.791,15.12a.725.725,0,0,0,0,1.035.75.75,0,0,0,1.051,0l1.915-1.887ZM5.573,9.362a.738.738,0,0,0,.743.732h6.368a.732.732,0,1,0,0-1.465H6.316A.738.738,0,0,0,5.573,9.362ZM0,5.491V5.439a.729.729,0,0,1,.219-.518L5,.215A.747.747,0,0,1,5.52,0h.054V4.654a.844.844,0,0,1-.849.837Z"
          fill="#6459a7" />
      </svg>
    </div>
    <h4>{{ label ? label : ('fileManager.dragAndDrop'|translate) }}</h4>
    <div>
      <span>{{( label ? 'fileManager.Or' : 'fileManager.supportedFiles' )|translate}}</span>
      <label [attr.for]="'fileDropRef_' + managerIndex">{{"fileManager.browseFiles"|translate}}</label>
    </div>
    <div class="hint text-decoration-none" *ngIf="showExtensions">
      <div>
        {{(supportedText ? supportedText :"fileManager.supportedFormats") |translate}}:
        <ng-container *ngIf="allowedExt.length < 14">
          <span *ngFor="let item of allowedExt; index as i" class="m-0 text-bold text-uppercase">
            {{ i == 0 ? item : ' or ' + item }}
          </span>
        </ng-container>
        <span *ngIf="allowedExt.length == 14">PDF, DOC, JPG, and PNG</span>
      </div>

      <div><span *ngIf="maxSize && showMaxSize">{{"fileManager.maximumUploadFileSize"|translate}}: <span
            class="text-bold">{{maxSize}}{{'forms.MB' | translate}}</span></span></div>
    </div>
  </div>

  <div *ngIf="selectedfilesCount > maxFiles && maxFiles === 1" class="has-error">
    {{ 'fileManager.Only One File is allowed' | translate }}
  </div>
  <ng-container *ngIf="!renderBtn">
    <div *ngIf="selectedfilesCount > maxFiles && maxFiles > 1" class="has-error">
      {{ "forms.maxUploadedFilesExceeded" | translate : { num: maxFiles } }}
    </div>
    <div *ngIf="invalidFile" class="has-error">{{"fileManager.invalidFileExtensions"|translate}}</div>
    <div *ngIf="fileMaxSiZeErorr" class="has-error">{{"fileManager.maxFileSize"|translate}} {{maxSize}}{{'forms.MB' |
      translate}}</div>
  </ng-container>

  <div *ngIf="fileMaxNameSiZeErorr" class="has-error"></div>
  <div *ngIf="!files.length && isRequired && isSubmitted" class="has-error">
    {{"forms.Required"|translate}}
  </div>
  <div *ngIf="!files.length" [hidden]="docsEditable" class="dnd-container">
    <h4>{{"fileManager.noFiles"|translate}}</h4>
  </div>
  <div class="files-list" [ngClass]="{ 'w-50': showAttachmentsTitle }">
    <h3 class="subtitle-form" *ngIf="files && files.length && showAttachmentsTitle">
      {{"wikiCategories.Attachments"|translate}}</h3>
    <div class="row">
      <div *ngFor="let file of files; let i = index" [ngClass]="{ 'col-md-6': cols == 2 }" class="col-12">
        <div *ngIf="file" class="file-item">
          <div class="file-details">
            <div class="file-icon">
              <img *ngIf="fileType(file.name) == 'doc'" src="./assets/images/file-icons/file-doc-icon.svg" />
              <img *ngIf="fileType(file.name) == 'jpg'" src="./assets/images/file-icons/file-jpg-icon.svg" />
              <img *ngIf="fileType(file.name) == 'pdf'" src="./assets/images/file-icons/file-pdf-icon.svg" />
              <img *ngIf="fileType(file.name) == 'png'" src="./assets/images/file-icons/file-png-icon.svg" />
              <img *ngIf="fileType(file.name) == 'pptx'" src="./assets/images/file-icons/file-ppt-icon.svg" />
              <img *ngIf="fileType(file.name) == 'xls'" src="./assets/images/file-icons/file-xls-icon.svg" />
              <img *ngIf="fileType(file.name) == 'zip'" src="./assets/images/file-icons/file-zip-icon.svg" />
              <img *ngIf="fileType(file.name) == 'wsi'" src="./assets/images/file-icons/file-wsi-icon.svg" />
              <img *ngIf="fileType(file.name) == 'json'" src="./assets/images/file-icons/file-json-icon.svg" />
              <img *ngIf="fileType(file.name) == 'txt'" src="./assets/images/file-icons/file-txt-icon.svg" />
              <img *ngIf="fileType(file.name) == 'crt'" src="./assets/images/file-icons/file-crt-icon.svg" />
              <img *ngIf="fileType(file.name) == 'cer'" src="./assets/images/file-icons/file-crt-icon.svg" />
              <img *ngIf="fileType(file.name) == 'pfx'" src="./assets/images/file-icons/file-pfx-icon.svg" />
              <img
                *ngIf="fileType(file.name) == 'mp4' || fileType(file.name) == 'avi' || fileType(file.name) == 'mkv' || fileType(file.name) == 'mov'"
                src="./assets/images/file-icons/file-video-icon.svg" />
            </div>
            <div>
              <label [title]="file?.name">{{ file?.name }}</label>
              <span>{{ formatBytes(file?.size) }}</span>
            </div>
          </div>
          <div class="file-btn">
            <a *ngIf="safeDownload(file.path) as href" [download]="file.path" [href]="href" class="download">
              <svg height="20" viewBox="0 0 20 20" width="20">
                <path
                  d="M2.4,20A2.5,2.5,0,0,1,0,17.508V11.42a.294.294,0,0,1,.093-.2l3.07-5.918a.432.432,0,0,1,.419-.219H5.349a.489.489,0,0,1,0,.977H3.861L1.3,10.953h2.6A3.047,3.047,0,0,1,6.7,12.836a2.154,2.154,0,0,0,1.953,1.3h2.7a2.154,2.154,0,0,0,1.953-1.3,3.047,3.047,0,0,1,2.791-1.883h2.651L16.582,6.064h-1.93a.489.489,0,0,1,0-.977h2.233a.457.457,0,0,1,.442.244l2.6,5.893a.464.464,0,0,1,.07.2v6.088A2.5,2.5,0,0,1,17.6,20Zm7.279-8.68L6.512,7.973a.511.511,0,0,1,0-.588.453.453,0,0,1,.651-.1L9.535,9.781V.49a.466.466,0,1,1,.93,0V9.781l2.372-2.494a.446.446,0,0,1,.558,0,.507.507,0,0,1,.093.686L10.326,11.32a.284.284,0,0,1-.027.029.428.428,0,0,1-.624-.029Z"
                  fill="#6B6D85" id="download-btn" />
              </svg>
            </a>
            <button (click)="deleteFile(i, file.id)" type="button" class="btn-delete">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18">
                <path id="ic_delete"
                  d="M56.917,3H54.592a3.757,3.757,0,0,0-3.675-3h-1.5a3.757,3.757,0,0,0-3.675,3H43.417a.75.75,0,0,0,0,1.5h.75v9.75A3.755,3.755,0,0,0,47.917,18h4.5a3.755,3.755,0,0,0,3.75-3.75V4.5h.75a.75.75,0,0,0,0-1.5Zm-7.5,9.75a.75.75,0,0,1-1.5,0V8.25a.75.75,0,1,1,1.5,0v4.5Zm3,0a.75.75,0,0,1-1.5,0V8.25a.75.75,0,1,1,1.5,0ZM47.3,3a2.255,2.255,0,0,1,2.122-1.5h1.5A2.255,2.255,0,0,1,53.039,3Z"
                  transform="translate(-42.667)" fill="#dc3545" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
